import { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

type OwnershipSelectCheckboxProps = {
    id?: string;
    checked: boolean | "indeterminate";
    onCheckedChange: () => void;
    onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
    className?: string;
    "aria-label"?: string;
};

/** Native checkbox styled like the user-portal multiselect delete control. */
function OwnershipSelectCheckbox({
    id,
    checked,
    onCheckedChange,
    onClick,
    className,
    "aria-label": ariaLabel,
}: OwnershipSelectCheckboxProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const isIndeterminate = checked === "indeterminate";

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = isIndeterminate;
        }
    }, [isIndeterminate]);

    return (
        <input
            ref={inputRef}
            id={id}
            type="checkbox"
            className={cn("gs-ownership-select-checkbox", className)}
            checked={checked === true}
            onChange={onCheckedChange}
            onClick={onClick}
            aria-label={ariaLabel}
        />
    );
}

export default OwnershipSelectCheckbox;
